import Vue from 'vue'

import date from './date'
import translit from './translit'
import options from './options'
import item from './item'
import getCurrencyCode from './getCurrencyCode'
import price from './price'
import parsingSearchId from './parsingSearchId'
import textCase from './textCase'
import quotas from './quotas'
import inputEn from './inputEn'
import inputRu from './inputRu'

Vue.prototype.$format = {
  date,
  translit,
  options,
  item,
  getCurrencyCode,
  price,
  parsingSearchId,
  textCase,
  quotas,
  inputEn,
  inputRu
}
